import styled from 'styled-components';

const BoxWrapper = styled.div`
    padding: 10px;
    border: 1px solid red;
    border-radius:5px;
    margin-bottom:10px;
    background: #FEFCFF;
    color: #495057;
`;

export default BoxWrapper